module.exports = __webpack_public_path__ + "static/media/messageImage_1612839552567.ed209318.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/messageImage_1612839552567.jpg
// module id = 633
// module chunks = 0